"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_dropzone_1 = require("react-dropzone");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DropZone = function (_a) {
    var onFileDrop = _a.onFileDrop;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _b = (0, react_dropzone_1.useDropzone)({
        onDrop: onFileDrop,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
    return (react_1.default.createElement("div", __assign({}, getRootProps(), { className: styles_module_scss_1.default.container }),
        react_1.default.createElement("input", __assign({}, getInputProps(), { multiple: false })),
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
                t('dropOrBrowse'),
                ' ',
                react_1.default.createElement("span", { className: styles_module_scss_1.default.browse }, t('upload'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.secondaryDescription },
                "jpg, png. ",
                t('maxSizeFiles', { maxSize: '1' })))),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "100%", height: "44px", text: "upper" }, t('upload')),
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.secondaryDescription },
                "jpg, png. ",
                react_1.default.createElement("br", null),
                " ",
                t('maxSizeFiles', { maxSize: '1' }))))));
};
exports.default = DropZone;
